import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from 'src/app/app.constants';
import { EmployeeIdpConfirmViewModel } from '../viewModels/employeeIdpConfirmViewModel';

@Injectable({
  providedIn: 'root',
})
export class IdpService {
  private baseUrl: string;
  constructor(private http: HttpClient, private configuration: Configuration) {
    this.baseUrl = this.configuration.buildEndpoint('Idp/');
  }

  getIdpConfirmation(email: string): Observable<EmployeeIdpConfirmViewModel> {
    return this.http.get<EmployeeIdpConfirmViewModel>(`${this.baseUrl}GetIdpConfirmation/${email}`);
  }

}
